import * as React from "react"
import { Text, View } from "react-native"
import { Icons } from "../../config/icons";
import { TouchableKiaIcon } from "../icon/touchable-icon";
import { useNavigation } from '@react-navigation/native';
import * as styles from "./kia-header.style";

export interface KiaHeaderProps {
    title: string,
    onBackPress: any,
    hideBackIcon?: boolean
}

export function KiaHeader(props: KiaHeaderProps){
    const navigation = useNavigation();    
    const nav = () => navigation.navigate("newSearch");
    return(
        <View style={styles.baseView}>
            {
                !props.hideBackIcon && <TouchableKiaIcon onPress={props.onBackPress} iconProps={{src: Icons.back}} />
            }            
            <View style={styles.titleView}><Text style={styles.title}>{props.title}</Text></View>
            <TouchableKiaIcon onPress={nav} iconProps={{src: Icons.search}} />
        </View>        
    )
}